import type { ReactElement } from 'react';
import type { PersonalInstalledToolListItem } from '@kirin/api-client/contracts/account-shadow-ai-installed-tools';
import { SourceBadges } from '../components/SourceBadges';
import { ExtrasCard } from '../components/ExtrasCard';

export function ExpandedToolRow({
  row,
}: {
  row: Pick<PersonalInstalledToolListItem, 'sources' | 'extras'>;
}): ReactElement {
  return (
    <div className="pl-8 space-y-2 text-sm">
      <div className="flex items-start gap-2">
        <span className="text-muted-foreground whitespace-nowrap">
          Detected via:
        </span>
        <SourceBadges sources={row.sources} />
      </div>
      {row.extras && <ExtrasCard extras={row.extras} />}
    </div>
  );
}
